<div
  class="consolidated-dashboard-container"
  [class.consolidated-dashboard-container--open]="!panel() || (show && show())"
  [class.consolidated-dashboard-container--panel]="panel()"
  [class.consolidated-dashboard-container--regular]="!panel()"
>
  <div
    [class.consolidated-dashboard--hidden]="show !== undefined && !show()"
    [class.consolidated-dashboard--panel]="panel()"
    class="consolidated-dashboard b4a-tv-dashboard"
  >
    <app-dashboard-header
      title="Consolidado de Lojas e Assinaturas"
    ></app-dashboard-header>

    <main class="b4a-main-container">
      <div class="b4a-metrics-grid">
        <app-dashboard-card
          class="b4a-metric-card b4a-metric-primary"
          layout="metric"
        >
          <div class="b4a-card-header">
            <div class="b4a-card-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="b4a-card-title-section">
              <h3 class="b4a-card-title">Total Assinaturas</h3>
              <p class="b4a-card-subtitle">glam + Clube da Men's</p>
            </div>
          </div>
          <div class="b4a-card-content">
            <div
              class="b4a-metric-value"
              [class.loading]="
                !subscriptionsTotal || subscriptionsTotal() === undefined
              "
            >
              <ng-container
                *ngIf="
                  subscriptionsTotal && subscriptionsTotal();
                  else totalSubscriptionsLoading
                "
              >
                <span class="b4a-metric-number">
                  {{ subscriptionsTotal()?.total || 0 | number: '1.0-0' }}
                </span>
              </ng-container>
            </div>
          </div>
          <div class="b4a-card-footer">
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Última Venda: glam</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    lastSubscriptionGlam() !== undefined;
                    else glamLastSaleLoading
                  "
                >
                  <ng-container
                    *ngIf="
                      lastSubscriptionGlam() !== null;
                      else glamLastSaleEmpty
                    "
                  >
                    {{ lastSubscriptionGlam() | date: 'dd/MM/yyyy HH' }}h{{
                      lastSubscriptionGlam() | date: 'mm'
                    }}
                  </ng-container>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Última Venda: Clube da Men's</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    lastSubscriptionMens() !== undefined;
                    else mensLastSaleLoading
                  "
                >
                  <ng-container
                    *ngIf="
                      lastSubscriptionMens() !== null;
                      else mensLastSaleEmpty
                    "
                  >
                    {{ lastSubscriptionMens() | date: 'dd/MM/yyyy HH' }}h{{
                      lastSubscriptionMens() | date: 'mm'
                    }}
                  </ng-container>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row b4a-detail-row--spacer" aria-hidden="true">
              <span class="b4a-detail-label">-</span>
              <span class="b4a-detail-value">-</span>
            </div>
          </div>
        </app-dashboard-card>

        <app-dashboard-card
          class="b4a-metric-card b4a-metric-success"
          layout="metric"
        >
          <div class="b4a-card-header">
            <div class="b4a-card-icon">
              <i class="pi pi-dollar"></i>
            </div>
            <div class="b4a-card-title-section">
              <h3 class="b4a-card-title">Receita - Lojas</h3>
              <p class="b4a-card-subtitle">glam + Men's Market</p>
            </div>
          </div>
          <div class="b4a-card-content">
            <div class="b4a-metric-value" [class.loading]="!shopIncome()">
              <ng-container *ngIf="shopIncome(); else shopIncomeLoading">
                <span class="b4a-metric-number" appValueChange>
                  {{ shopIncome().total || 0 | currency: 'BRL' }}
                </span>
              </ng-container>
            </div>
          </div>
          <div class="b4a-card-footer">
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Última Venda: glam</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    lastIncomeOrderGlam() !== undefined;
                    else glamLastSaleLoading
                  "
                >
                  <ng-container
                    *ngIf="
                      lastIncomeOrderGlam() !== null;
                      else glamLastSaleEmpty
                    "
                  >
                    {{ lastIncomeOrderGlam() | date: 'dd/MM/yyyy HH' }}h{{
                      lastIncomeOrderGlam() | date: 'mm'
                    }}
                  </ng-container>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Última Venda: Men's Market</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    lastIncomeOrderMens() !== undefined;
                    else mensLastSaleLoading
                  "
                >
                  <ng-container
                    *ngIf="
                      lastIncomeOrderMens() !== null;
                      else mensLastSaleEmpty
                    "
                  >
                    {{ lastIncomeOrderMens() | date: 'dd/MM/yyyy HH' }}h{{
                      lastIncomeOrderMens() | date: 'mm'
                    }}
                  </ng-container>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Cupons Bflus:</span>
              <span class="b4a-detail-value">
                <ng-container *ngIf="couponIncome(); else couponIncomeLoading">
                  {{ couponIncome().total || 0 | currency: 'BRL' }}
                  <span
                    class="b4a-metric-percentage"
                    *ngIf="shopIncome()?.total"
                  >
                    ({{ couponPercentage() | number: '1.0-1' }}%)
                  </span>
                </ng-container>
              </span>
            </div>
          </div>
        </app-dashboard-card>

        <app-dashboard-card
          class="b4a-metric-card b4a-metric-info"
          layout="metric"
        >
          <div class="b4a-card-header">
            <div class="b4a-card-icon">
              <i class="pi pi-star"></i>
            </div>
            <div class="b4a-card-title-section">
              <h3 class="b4a-card-title">Marcas Próprias</h3>
              <p class="b4a-card-subtitle">Glam Beauty, Men's, Ella, Malmo</p>
            </div>
          </div>
          <div class="b4a-card-content">
            <div class="b4a-metric-value" [class.loading]="!ownBrandsIncome()">
              <ng-container
                *ngIf="ownBrandsIncome(); else ownBrandsIncomeLoading"
              >
                <div class="b4a-metric-row">
                  <span class="b4a-metric-number">
                    {{ ownBrandsIncome().total || 0 | currency: 'BRL' }}
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="b4a-card-footer">
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Última Venda:</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    ownBrandsIncome()?.createdAt !== undefined;
                    else ownBrandsLastSaleLoading
                  "
                >
                  <ng-container
                    *ngIf="
                      ownBrandsIncome()?.createdAt !== null;
                      else ownBrandsLastSaleEmpty
                    "
                  >
                    {{
                      ownBrandsIncome()?.createdAt | date: 'dd/MM/yyyy HH'
                    }}h{{ ownBrandsIncome()?.createdAt | date: 'mm' }}
                  </ng-container>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row">
              <span class="b4a-detail-label"
                >% de vendas sobre Receita Total das Lojas:</span
              >
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="
                    ownBrandsIncome() && shopIncome();
                    else ownBrandsLastSaleLoading
                  "
                >
                  <span
                    class="b4a-metric-percentage"
                    *ngIf="shopIncome()?.total"
                  >
                    ({{ ownBrandsPercentage() | number: '1.0-1' }}%)
                  </span>
                </ng-container>
              </span>
            </div>
            <div class="b4a-detail-row b4a-detail-row--spacer" aria-hidden="true">
              <span class="b4a-detail-label">-</span>
              <span class="b4a-detail-value">-</span>
            </div>
          </div>
        </app-dashboard-card>

        <app-dashboard-card
          class="b4a-metric-card b4a-metric-warning"
          layout="metric"
        >
          <div class="b4a-card-header">
            <div class="b4a-card-icon">
              <i class="pi pi-chart-line"></i>
            </div>
            <div class="b4a-card-title-section">
              <h3 class="b4a-card-title">Margem Contribuição - Lojas</h3>
              <p class="b4a-card-subtitle">glam + Men's Market</p>
            </div>
          </div>
          <div class="b4a-card-content">
            <div
              class="b4a-metric-value"
              [class.loading]="!contributionResponse()"
            >
              <ng-container
                *ngIf="contributionResponse(); else contributionResponseLoading"
              >
                <div class="b4a-metric-row">
                  <span class="b4a-metric-number">
                    {{
                      contributionResponse().contributionMargin || 0
                        | currency: 'BRL'
                    }}
                  </span>
                  <span class="b4a-metric-percentage">
                    ({{
                      contributionResponse().contributionMarginPercentage || 0
                        | number: '1.0-2'
                    }}%)
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="b4a-card-footer">
            <div class="b4a-detail-row">
              <span class="b4a-detail-label">Status</span>
              <span class="b4a-detail-value">
                <ng-container
                  *ngIf="contributionResponse(); else contributionStatusLoading"
                >
                  <span
                    [class.b4a-status-positive]="
                      contributionResponse().contributionMargin >= 0
                    "
                    [class.b4a-status-negative]="
                      contributionResponse().contributionMargin < 0
                    "
                  >
                    {{
                      contributionResponse().contributionMargin >= 0
                        ? 'Positiva'
                        : 'Negativa'
                    }}
                  </span>
                </ng-container>
              </span>
            </div>
            <div
              class="b4a-detail-row b4a-detail-row--spacer"
              aria-hidden="true"
            >
              <span class="b4a-detail-label">-</span>
              <span class="b4a-detail-value">-</span>
            </div>
            <div
              class="b4a-detail-row b4a-detail-row--spacer"
              aria-hidden="true"
            >
              <span class="b4a-detail-label">-</span>
              <span class="b4a-detail-value">-</span>
            </div>
          </div>
        </app-dashboard-card>
      </div>
    </main>

    <app-dashboard-footer>
      <div class="b4a-footer-section">
        <div class="b4a-footer-logos">
          <img
            src="assets/images/settings/b4abi.svg"
            alt="Logo B4A BI"
            class="b4a-footer-logo"
          />
          <img
            src="assets/images/settings/bi.svg"
            alt="Logo BI"
            class="b4a-footer-logo"
          />
        </div>
      </div>
    </app-dashboard-footer>
  </div>

  <ng-template #totalSubscriptionsLoading>
    <span class="b4a-metric-number">
      <div class="b4a-spinner b4a-spinner-large"></div>
    </span>
  </ng-template>
  <ng-template #glamLastSaleLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
  <ng-template #glamLastSaleEmpty>-</ng-template>
  <ng-template #mensLastSaleLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
  <ng-template #mensLastSaleEmpty>-</ng-template>
  <ng-template #shopIncomeLoading>
    <span class="b4a-metric-number">
      <div class="b4a-spinner b4a-spinner-large"></div>
    </span>
  </ng-template>
  <ng-template #ownBrandsIncomeLoading>
    <span class="b4a-metric-number">
      <div class="b4a-spinner b4a-spinner-large"></div>
    </span>
  </ng-template>
  <ng-template #ownBrandsLastSaleLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
  <ng-template #ownBrandsLastSaleEmpty>-</ng-template>
  <ng-template #couponIncomeLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
  <ng-template #contributionResponseLoading>
    <div class="b4a-spinner b4a-spinner-large"></div>
  </ng-template>
  <ng-template #contributionStatusLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
  <ng-template #footerLoading>
    <div class="b4a-spinner"></div>
  </ng-template>
</div>
